// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/DotGothic16-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../fonts/PressStart2P-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../fonts/PixelifySans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../fonts/GohuFont14NerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../fonts/BigBlueTerm437NerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../fonts/HeavyDataNerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DotGothic16";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"); }

@font-face {
  font-family: "Press Start 2P";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }

@font-face {
  font-family: "Pixelify Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }

@font-face {
  font-family: "Gohu";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }

@font-face {
  font-family: "Big Blue";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }

@font-face {
  font-family: "Heavy Data";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }

:root {
  --main-font: "Pixelify Sans", sans-serif;
  --clock-font: "DotGothic16", sans-serif;
  --log-in-font: "Press Start 2P", sans-serif;
  --Gohu-test: "Gohu", sans-serif;
  --Big-Blue-test: "Big Blue", sans-serif;
  --Heavy-Data-test: "Heavy Data", sans-serif; }

.moveable-app {
  position: absolute;
  border: 1px solid #cccccc;
  background-color: white;
  z-index: 1000;
  width: 70vw;
  max-width: 1300px;
  height: 75vh;
  display: flex;
  flex-direction: column;
  overflow: hidden; }

.app-header {
  background-color: #d0d0d0;
  display: flex;
  flex-direction: column; }
  .app-header * {
    font-weight: bold; }

.title-x-div-test {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start; }

.title-bar-test {
  background-color: #011E75;
  color: white;
  width: 100%;
  padding: 5px 10px;
  border-top: 1px white solid;
  border-right: 1px black solid;
  border-bottom: 1px black solid;
  border-left: 1px white solid;
  margin-top: 2px;
  font-family: var(--main-font); }
  .title-bar-test:hover {
    cursor: move; }

.app-content {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  background-color: white; }

.left-bar {
  color: white;
  height: 100%;
  background-color: #585858;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center; }
  .left-bar > div {
    width: 100%;
    height: 50px; }
    .left-bar > div:hover {
      cursor: pointer;
      background-color: rgba(255, 255, 255, 0.25); }

.content-box {
  width: 25%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/style_imports/_fonts.scss","webpack://./src/components/MoveableModal/LogApp.scss"],"names":[],"mappings":"AAAA;EACI,0BAA0B;EAC1B,+DAAkE,EAAA;;AAGtE;EACI,6BAA6B;EAC7B,4CAAgD,EAAA;;AAGpD;EACI,4BAA4B;EAC5B,4CAAgD,EAAA;;AAGpD;EACI,mBAAmB;EACnB,4CAAsD,EAAA;;AAG1D;EACI,uBAAuB;EACvB,4CAA0D,EAAA;;AAG9D;EACI,yBAAyB;EACzB,4CAAqD,EAAA;;AAGzD;EACI,wCAAY;EACZ,uCAAa;EACb,2CAAc;EACd,+BAAY;EACZ,uCAAgB;EAChB,2CAAkB,EAAA;;AClCtB;EACI,kBAAkB;EAClB,yBAAoC;EACpC,uBAAoC;EACpC,aAAa;EACb,WAAW;EAEX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAA;;AAYpB;EACI,yBAAyB;EACzB,aAAa;EACb,sBAAsB,EAAA;EAH1B;IAMQ,iBAAiB,EAAA;;AAIzB;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB,EAAA;;AAG3B;EACI,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EAEf,6BAA6B,EAAA;EAXjC;IAcQ,YAAY,EAAA;;AAIpB;EACI,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB,EAAA;;AAG3B;EACI,YAAY;EAEZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAGhB,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAA;EAXvB;IAeQ,WAAW;IACX,YAAY,EAAA;IAhBpB;MAmBY,eAAe;MACf,2CAAsC,EAAA;;AAWlD;EAEI,UAAU;EACV,YAAY;EACZ,uBAAuB;EAEvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EAEvB,kBAAkB;EAClB,QAAQ,EAAA","sourcesContent":["@font-face {\n    font-family: \"DotGothic16\";\n    src: url(\"../../fonts/DotGothic16-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n    font-family: \"Press Start 2P\";\n    src: url(\"../../fonts/PressStart2P-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Pixelify Sans\";\n    src: url(\"../../fonts/PixelifySans-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Gohu\";\n    src: url(\"../../fonts/GohuFont14NerdFont-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Big Blue\";\n    src: url(\"../../fonts/BigBlueTerm437NerdFont-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Heavy Data\";\n    src: url(\"../../fonts/HeavyDataNerdFont-Regular.ttf\");\n}\n\n:root {\n    --main-font: \"Pixelify Sans\", sans-serif;\n    --clock-font: \"DotGothic16\", sans-serif;\n    --log-in-font: \"Press Start 2P\", sans-serif;\n    --Gohu-test: \"Gohu\", sans-serif;\n    --Big-Blue-test: \"Big Blue\", sans-serif;\n    --Heavy-Data-test: \"Heavy Data\", sans-serif;\n}","@import '../style_imports/fonts';\n\n.moveable-app {\n    position: absolute;\n    border: 1px solid rgb(204, 204, 204);\n    background-color: rgb(255, 255, 255);\n    z-index: 1000;\n    width: 70vw;\n    // width: 1300px;\n    max-width: 1300px;\n    height: 75vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n\n    // @media screen and (max-width: 430px) {\n    //     transform: translate(-50%, -50%);\n    //     width: 99%;\n    //     // height: 50vh;\n    //     max-width: none;\n    //     left: 50%;\n    //     top: 55%;\n    // }\n}\n\n.app-header {\n    background-color: #d0d0d0;\n    display: flex;\n    flex-direction: column;\n\n    & * {\n        font-weight: bold;\n    }\n}\n\n.title-x-div-test {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.title-bar-test {\n    background-color: #011E75;\n    color: white;\n    width: 100%;\n    padding: 5px 10px;\n    border-top: 1px white solid;\n    border-right: 1px black solid;\n    border-bottom: 1px black solid;\n    border-left: 1px white solid;\n    margin-top: 2px;\n\n    font-family: var(--main-font);\n\n    &:hover {\n        cursor: move;\n    }\n}\n\n.app-content {\n    height: 100%;\n    width: 100%;\n    overflow-y: auto;\n    display: flex;\n    background-color: white;\n}\n\n.left-bar {\n    color: white;\n    // width: 25%;\n    height: 100%;\n    background-color: #585858;\n    overflow-x: hidden;\n    overflow-y: auto;\n    // transition: width .5s;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    // justify-content: center;\n\n    &>div {\n        width: 100%;\n        height: 50px;\n\n        &:hover {\n            cursor: pointer;\n            background-color: rgba($color: #FFFFFF, $alpha: .25);\n        }\n    }\n}\n\n// .mystical-line {\n//     background-color: blue;\n//     width: 10%;\n//     height: 100%;\n// }\n\n.content-box {\n    // color: white;\n    width: 25%;\n    height: 100%;\n    background-color: white;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    position: absolute;\n    right: 0;\n\n    // transition: width .5s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
